import { render } from "./MensajeForm.vue?vue&type=template&id=70f6990c&scoped=true"
import script from "./MensajeForm.vue?vue&type=script&lang=js"
export * from "./MensajeForm.vue?vue&type=script&lang=js"

import "./MensajeForm.vue?vue&type=style&index=0&id=70f6990c&scoped=scoped&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f6990c"]])

export default __exports__